var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingPlaceholderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 362,
    viewBox: "0 0 200 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.877 109.498C163.878 121.045 162.251 129.672 159.305 136.471C156.37 143.244 152.072 148.332 146.524 152.728C140.937 157.155 134.108 160.863 126.103 164.876C118.409 168.733 109.638 172.868 100.131 178.122C90.622 172.869 81.8503 168.735 74.1551 164.879C66.1495 160.868 59.3209 157.16 53.734 152.735C48.1856 148.339 43.8861 143.251 40.9508 136.479C38.004 129.68 36.3758 121.054 36.3751 109.507L36.3724 69.7715L163.874 69.7629L163.877 109.498Z",
    fill: "white",
    stroke: "#662577",
    strokeWidth: 4.13687
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3358 51.4378L175.898 51.431C180.088 51.431 183.485 54.8282 183.485 59.0185C183.486 63.2086 180.09 66.6053 175.899 66.6057L24.3374 66.6124C20.1471 66.6126 16.7494 63.2161 16.7488 59.0259C16.7483 54.8356 20.1454 51.438 24.3358 51.4378Z",
    fill: "#F4E8F8",
    stroke: "#662577",
    strokeWidth: 4.13687
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3519 296.388L175.913 296.381C180.104 296.381 183.501 299.778 183.502 303.969C183.502 308.159 180.105 311.556 175.915 311.557L24.3535 311.563C20.1629 311.564 16.7653 308.167 16.7649 303.976C16.7645 299.785 20.1613 296.388 24.3519 296.388Z",
    fill: "#F4E8F8",
    stroke: "#662577",
    strokeWidth: 4.13687
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.08 165.003L75.3977 110.679L59.1241 93.9992L34.2374 68.2469L34.3249 110.506C34.328 157.467 60.7924 159.564 100.126 181.499C111.131 175.36 124.591 167.5 130.08 165.003Z",
    fill: "#662577"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.526 209.265C152.074 213.66 156.373 218.749 159.308 225.521C162.255 232.32 163.884 240.946 163.885 252.493L163.887 292.227L36.3848 292.236L36.3822 252.502C36.3815 240.955 38.0097 232.328 40.9556 225.529C43.8901 218.757 48.1881 213.667 53.7359 209.271C59.3222 204.845 66.151 201.137 74.1561 197.125C81.8509 193.267 90.621 189.131 100.129 183.876C109.638 189.129 118.409 193.265 126.104 197.121C134.11 201.133 140.939 204.839 146.526 209.265Z",
    fill: "white",
    stroke: "#662577",
    strokeWidth: 4.13687
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.737 293.812L34.8322 293.82L34.8294 252.501C34.8283 235.662 38.2438 224.689 44.3851 216.507C50.4803 208.386 59.3034 202.955 70.3366 197.29L164.737 293.812Z",
    fill: "#662577",
    stroke: "#662577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingPlaceholderIcon);
export default __webpack_public_path__ + "static/media/loading_placeholder_icon.6fc97c97.svg";
export { ForwardRef as ReactComponent };